import { OnInit } from '@angular/core';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { FormGroup } from '@angular/forms';
var ModalConfirmationPointsComponent = /** @class */ (function () {
    function ModalConfirmationPointsComponent(dialogRef, data, snackBar) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.snackBar = snackBar;
        console.log('data', data);
    }
    ModalConfirmationPointsComponent.prototype.cancel = function () {
        this.dialogRef.close('cancel');
    };
    ModalConfirmationPointsComponent.prototype.confirm = function () {
        this.dialogRef.close(1);
    };
    ModalConfirmationPointsComponent.prototype.ngOnInit = function () {
    };
    return ModalConfirmationPointsComponent;
}());
export { ModalConfirmationPointsComponent };
